import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { UserPrivilegeEnum } from '../../../../enums/rights/user-privilege.enum';
import { ResetStateDefaults } from '../../../base-action-class.model';
import { RSetting } from './r-setting.action';

interface RSettingXsStateModel{
  viewAllSetting: string;
  viewOrganizationSetting: string;
}

const getDefaults = (): RSettingXsStateModel => ({
  viewAllSetting: null,
  viewOrganizationSetting: null,
});

@State<RSettingXsStateModel>({
  name: 'rSetting',
  defaults: getDefaults()
})
@Injectable()
export class RSettingXsState{

  //region SELECTOR

  @Selector()
  static canViewAllSetting(state: RSettingXsStateModel): boolean {
    return state.viewAllSetting != null;
  }

  @Selector()
  static canViewOrganizationSetting(state: RSettingXsStateModel): boolean {
    return state.viewOrganizationSetting != null;
  }


  //endregion

  //region ACTIONS
  @Action(RSetting.SetSettingPrivileges)
  public setSettingPrivileges(ctx: StateContext<RSettingXsStateModel>, action: RSetting.SetSettingPrivileges) {
    const state = ctx.getState();
    const settingPrivileges = [...action.activeUserRightInfoDtoModel.settingPrivileges];

    //find user privilege data model
    const viewAllSetting = settingPrivileges.find(id => id === UserPrivilegeEnum.VIEW_ALL_SETTINGS);
    const viewOrganizationSetting = settingPrivileges.find(id => id === UserPrivilegeEnum.VIEW_ORGANIZATION_SETTINGS);

    //set the state
    ctx.setState({
      ...state,
      viewAllSetting: viewAllSetting,
      viewOrganizationSetting: viewOrganizationSetting,
    });
  }

  @Action(ResetStateDefaults)
  public resetDefaults(ctx: StateContext<RSettingXsStateModel>): void {
    ctx.setState({...getDefaults()});
  }
  //endregion
}
